import { Link } from "./link";

export default function Footer() {
  return (
    <div className="footer-bar">
      <div className="inner">
        <div className="logo">
          <span>helpx.io</span>
        </div>
        <div>
          <Link href={"/privacy"} type={"secondary"} text={"Privacy"} />
          <Link href={"/terms"} type={"secondary"} text={"Terms"} />
          <span>&copy; Copyright 2024</span>
        </div>
      </div>
    </div>
  );
}
